<template>
  <rest
    :remote="remote"
    :table-columns="tableColumns"
    :form-initialize="formInitialize"
    :form-rules="formRules"
    :exportable="true"
    :export-visible="true"
    :create-able="true" :update-able="true" :delete-able="true"
    :use-drawer="true"
    drawer-width="50%"
  >
    <template slot="tableColumn-open" slot-scope="{ row }">
      <span :class="['status-dot-badge', row.open === 1 ? 'online' : 'closed']">
        <span class="dot"></span>
        {{ row.open === 1 ? '开启' : '关闭' }}
      </span>
    </template>

    <template slot="tableColumn-ruleType" slot-scope="{ row }">
      <el-tag :type="getRuleTypeTag(row.ruleType)" size="small" class="rule-type-tag">
        {{ getRuleTypeLabel(row.ruleType) }}
      </el-tag>
    </template>

    <template slot="tableColumn-scopeType" slot-scope="{ row }">
      <el-tag :type="getScopeTypeTag(row.scopeType)" size="small" class="scope-type-tag">
        {{ getScopeTypeLabel(row.scopeType) }}
      </el-tag>
    </template>
  </rest>
</template>

<script>
import Rest from '@/components/Spring/Rest'

export default {
  name: 'blacklists',
  components: { Rest },

  data () {
    return {
      remote: {
        path: 'ufo',
        resource: this.$options.name,
        realtime: true,
        createLabel: '新增黑名单'
      },
      formRules: {
        appId: [{ required: true, trigger: ['submit', 'blur'], message: '请填写游戏ID' }],
        open: [{ required: true, trigger: ['submit', 'blur'], message: '请选择是否开启' }],
        reason: [{ required: true, message: '请填写原因' }],
        ruleKey: [{ required: true, message: '请填写规则密钥' }],
        ruleType: [{ required: true, trigger: ['submit', 'blur'], message: '请填写规则类型' }],
        scopeType: [{ required: true, message: '请选择作用域类型' }],
        expiredTime: [{ required: true, message: '请选择解封时间' }]
      },
      listeners: {
      }
    }
  },
  computed: {
    formInitialize () {
      return {
        appId: this.appId
      }
    },
    appId () {
      return this.$store.getters.appId
    },
    tableColumns () {
      return [
        { label: 'ID', prop: 'id', hiddenForm: true, minWidth: 90 },
        {
          label: '游戏ID',
          prop: 'appId',
          minWidth: 120
        },
        {
          label: '是否开启',
          prop: 'open',
          type: 'select',
          options: [
            { value: 0, label: '否' },
            { value: 1, label: '是' }
          ]
        },
        { label: '原因', prop: 'reason', minWidth: 180 },
        { label: '规则密钥', prop: 'ruleKey', type: 'textarea', placeholder: '支持逗号分隔批量添加多个（例如：192.168.1.1,192.168.1.2）', showOverflowTooltip: true, minWidth: 220 },
        {
          label: '规则类型',
          prop: 'ruleType',
          type: 'select',
          options: [
            { value: 1, label: '用户' },
            { value: 2, label: 'ip' },
            { value: 3, label: '设备' }
          ]
        },
        {
          label: '作用域',
          prop: 'scopeType',
          type: 'select',
          options: [
            { value: 1, label: '封禁' },
            { value: 2, label: '充值' },
            { value: 3, label: '注册' }
          ]
        },
        {
          label: '过期时间',
          prop: 'expiredTime',
          type: 'datetime'
        }
      ]
    }
  },
  methods: {
    getScopeTypeLabel (type) {
      const map = { 1: '封禁', 2: '充值', 3: '注册' }
      return map[type] || type
    },
    getScopeTypeTag (type) {
      const map = { 1: 'danger', 2: 'success', 3: 'warning' }
      return map[type] || 'info'
    },
    getRuleTypeLabel (type) {
      const map = { 1: '用户', 2: 'ip', 3: '设备' }
      return map[type] || type
    },
    getRuleTypeTag (type) {
      const map = { 1: 'primary', 2: 'info', 3: 'warning' }
      return map[type] || 'info'
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.rule-type-tag,
.scope-type-tag {
  font-weight: 600;
  border-radius: 6px;
}

/* 深色模式下规则类型 Tag 适配 */
html.dark .rule-type-tag.el-tag--primary {
  color: #60a5fa !important;
  background-color: rgba(37, 99, 235, 0.15) !important;
  border-color: rgba(37, 99, 235, 0.3) !important;
}

html.dark .rule-type-tag.el-tag--info {
  color: #94a3b8 !important;
  background-color: rgba(148, 163, 184, 0.15) !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

html.dark .rule-type-tag.el-tag--warning {
  color: #fbbf24 !important;
  background-color: rgba(245, 158, 11, 0.15) !important;
  border-color: rgba(245, 158, 11, 0.3) !important;
}

/* 深色模式下作用域 Tag 适配 */
html.dark .scope-type-tag.el-tag--danger {
  color: #f87171 !important;
  background-color: rgba(239, 68, 68, 0.15) !important;
  border-color: rgba(239, 68, 68, 0.3) !important;
}

html.dark .scope-type-tag.el-tag--success {
  color: #34d399 !important;
  background-color: rgba(16, 185, 129, 0.15) !important;
  border-color: rgba(16, 185, 129, 0.3) !important;
}

html.dark .scope-type-tag.el-tag--warning {
  color: #fbbf24 !important;
  background-color: rgba(245, 158, 11, 0.15) !important;
  border-color: rgba(245, 158, 11, 0.3) !important;
}

html.dark .status-dot-badge.online {
  background-color: rgba(34, 197, 94, 0.15) !important;
  color: #4ade80 !important;
}

html.dark .status-dot-badge.closed {
  background-color: rgba(239, 68, 68, 0.15) !important;
  color: #f87171 !important;
}
</style>
